<template>
  <section
    class="highlights details-content"
    :class="hasHighlights || 'highlights--empty'"
  >
    <div class="container container--small">
      <div class="highlights__header">
        <h2 class="highlights__title">Highlights, notes and bookmarks</h2>
        <ExportHighlightsButton class="highlights__button" />
      </div>
      <div class="container highlights__container">
        <HighlightsList :doc="doc" :limit="2" :hideButtonOnMobile="true" />
        <div v-if="hasHighlights" class="highlights__btn-box">
          <router-link
            :to="{
              name: doc.routeNames().highlights,
              params: { url_slug: doc.url_slug },
            }"
            class="highlights__button highlights__view-all btn-outline-primary btns--white book-unit__btn btns btns--small btns--full"
          >
            <span>Show all highlights</span>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import HighlightsList from '@/app/components/doc/highlights/HighlightsList.vue'
import ExportHighlightsButton from '@/app/components/book/highlights/ExportHighlightsButton.vue'

import { DocView } from '@/models/doc'

const props = defineProps<{
  doc: DocView
}>()

const hasHighlights = computed(() => {
  return props.doc.highlights.length > 0
})
</script>
